import { useTranslation } from 'react-i18next'

interface Props {
  active: boolean
  onToggle: () => void
}

/** The Mine Leads star, as the Bedrifter and Biler tabs draw it. Stops the
 *  click from reaching the row, whose own click opens the bedrift page. */
export default function BookmarkStar({ active, onToggle }: Props) {
  const { t } = useTranslation('leads')
  const label = active ? t('bookmark.remove') : t('bookmark.add')
  return (
    <button
      onClick={e => { e.stopPropagation(); onToggle() }}
      title={label}
      aria-label={label}
      aria-pressed={active}
      className="hover:scale-110 transition-transform"
    >
      {active ? '⭐' : '☆'}
    </button>
  )
}
